import { APP_NAME } from '@aibees/shared/constants';

export function getHumanizedAppName() {
  return APP_NAME?.replace('-', ' ').toLowerCase();
}
